import { AGENT_COOKIE_NAME, AFFILIATE_COOKIE_NAME, getCookieValue } from "src/utils/cookie-utils";
import { readfile } from "src/utils/fileReader-utils";
import { getInstanceBackend } from "./axios";
import { Register } from "src/model/myTypes";

type postRegisterStartAction = {
  type: "POST_REGISTER_START";
  payload: { message: string; success: boolean };
};

type getIsUsernameFreeAction = {
  type: "IS_USERNAME_FREE";
  payload: { isFree: boolean };
};

type getIsValidHashAction = {
  type: "IS_VALID_HASH";
  payload: {
    isValid: boolean; hash: string, preData: {
      birthdate: string,
      country: string,
      cpf: string,
    }
  };
};

type getForgotPasswordAction = {
  type: "FORGOT_PASSWORD_RESPONSE";
  payload: { success: boolean; message: string };
};

type postRegisterContinueAction = {
  type: "POST_REGISTER_CONTINUE";
  payload: { RegisterContinueResponse: boolean; message: string };
};

type postRegisterNewPasswordAction = {
  type: "POST_REGISTER_NEW_PASSWORD";
  payload: { message: string; success: boolean };
};

type getisValidPasswordHashAction = {
  type: "IS_VALID_HASH_PASSWORD";
  payload: { isValid: boolean };
};

type resetResponseAction = {
  type: "RESET_RESPONSE";
};

type resetResponseSecondAction = {
  type: "RESET_RESPONSE_SECOND";
};

type resetResponsePasswordAction = {
  type: "RESET_RESPONSE_PASSWORD";
};

type getAgentInfoAction = {
  type: "UPDATE_AGENT_INFO";
  payload: {
    currencies: string[],
    requestDocumentsAddress: boolean,
    requestDocumentsIdentity: boolean,
    requestInformationAddress: boolean,
    requestInformationIdentity: boolean,
    autoApproveUser: boolean,
    phoneNumberResgistration: boolean,
    birthdateResgistration: boolean,
    cpfResgistration: boolean,
    forceEmailValidation: boolean,
  };
};

export type RegisterActions =
  | postRegisterStartAction
  | getIsUsernameFreeAction
  | getIsValidHashAction
  | resetResponseAction
  | getForgotPasswordAction
  | postRegisterContinueAction
  | postRegisterNewPasswordAction
  | resetResponseSecondAction
  | getisValidPasswordHashAction
  | resetResponsePasswordAction
  | getAgentInfoAction;

export function getIsUsernameFree(username: string) {
  return function action(dispatch: any) {
    getInstanceBackend()({
      method: "get",
      url: "/register-username-is-free",
      params: {
        u: username,
      },
    })
      .then((response) => {
        dispatch({
          type: "IS_USERNAME_FREE",
          payload: { isFree: response.data.isFree },
        });
      })
      .catch((error) => {
        // do nothing
        console.log("error in getIsUsernameFree", error);
      });
  };
}

export async function getIsCpfFree(cpf: string) {
  let result = { cpf: cpf, isFree: true };
  try {
    const response = await getInstanceBackend()({
      method: "get",
      url: "/register-cpf-is-free",
      params: {
        cpf: cpf,
      },
    });
    if (!!response && !!response.data && response.data.hasOwnProperty("cpf") && response.data.hasOwnProperty("isFree")) {
      result = response.data as unknown as typeof result;
    }
  } catch (error) {
    // do nothing
    console.log("error in getIsCpfFree", error);
  }
  return result;
}

export function postRegisterStart(
  email: string,
  firstname: string,
  lastname: string,
  country: string,
  currency: string,
  phoneNumber: string,
  birthdate: string,
  cpf: string,
  turnover: string,
  isTermsAccepted: boolean,
  lang: string,
  token: string
) {
  const agentCookieValue = getCookieValue(AGENT_COOKIE_NAME);
  const affiliateCookieValue = getCookieValue(AFFILIATE_COOKIE_NAME);

  return function action(dispatch: any) {
    getInstanceBackend()({
      method: "POST",
      url: "/register-start",
      data: {
        email: email,
        firstname: firstname,
        lastname: lastname,
        "country-iso2": country,
        currency: currency,
        phoneNumber: phoneNumber,
        birthdate: birthdate,
        cpf: cpf,
        turnover: turnover,
        isTermsAccepted: isTermsAccepted,
        lang: lang,
        token: token,
        aid: !!agentCookieValue ? agentCookieValue : null,
        affid: !!affiliateCookieValue ? affiliateCookieValue : null,
      },
    })
      .then((response) => {
        dispatch({
          type: "POST_REGISTER_START",
          payload: {
            message: response.data.message,
            success: response.data.success,
          },
        });
      })
      .catch((error) => {
        console.log("error in postRegisterStart", error);
      });
  };
}

export function isValidHash(hash: string | null) {
  return function action(dispatch: any) {
    const request = getInstanceBackend()({
      method: "GET",
      url: "/register-hash",
      params: {
        h: hash,
      },
    });
    return request
      .then((response) => {
        dispatch({
          type: "IS_VALID_HASH",
          payload: {
            isValid: response.data.isValid,
            hash: hash,
            preData: response.data.preData
          },
        });
      })
      .catch((error) => {
        // do nothing
        console.log("error in isValidHash", error);
      });
  };
}

export function postRegisterContinue(
  hash: string,
  usernameDesire: string,
  userPassword: string | undefined,
  nationalityCountryIso2: string,
  nationalityId: string,
  // nationalityDoc: string,
  nationalityDocFile: File | undefined,
  nationalityDocFile_B: File | undefined,
  addressCountryIso2: string,
  // addressCountry: string,
  address: string,
  addressPostCode: string,
  addressCity: string,
  // addressDoc: string,
  addressDocFile: File | undefined,
  lang: string
) {
  return async function action(dispatch: any, getState: any) {
    const stateRegister: Register = getState().register;
    // var array: File[] = [];
    // array.push(nationalityDocFile);
    // array.push(addressDocFile);
    // const files = await readmultifiles(array);
    // debugger;
    // console.log("files[0]", files[0]);
    const formData = new FormData();
    formData.append("hash", hash);
    formData.append("lang", lang);
    formData.append("username-desired", usernameDesire);
    if (userPassword) {
      formData.append("password", userPassword);
    }

    // Obligatory text information if requestInformationIdentity from payments api is true
    if (stateRegister.requestInformationIdentity) {
      formData.append("nationality-id", nationalityId);
      formData.append("nationality-country-iso2", nationalityCountryIso2);
    }

    // Obligatory document if requestDocumentsIdentity from payments api is true
    if (stateRegister.requestDocumentsIdentity && nationalityDocFile) {
      const natFile = await readfile(nationalityDocFile);
      formData.append("nationality-doc", nationalityDocFile.name);
      formData.append("nationality-doc-file", natFile as string);
    }

    // Optional document if requestDocumentsIdentity from payments api is true
    if (stateRegister.requestDocumentsIdentity && nationalityDocFile_B) {
      const natFile = await readfile(nationalityDocFile_B);
      formData.append("nationality-doc-back", nationalityDocFile_B.name);
      formData.append("nationality-doc-back-file", natFile as string);
    }

    // Obligatory text information if requestInformationAddress from payments api is true
    if (stateRegister.requestInformationAddress) {
      formData.append("address-country-iso2", addressCountryIso2);
      formData.append("address-street-and-numbers", address);
      formData.append("address-post-code", addressPostCode);
      formData.append("address-city", addressCity);
    }

    // Obligatory document if requestDocumentsAddress from payments api is true
    if (stateRegister.requestDocumentsAddress && addressDocFile) {
      const addressFile = await readfile(addressDocFile);
      formData.append("address-doc", addressDocFile.name);
      formData.append("address-doc-file", addressFile as string);
    }

    dispatch(function action(dispatch: any) {
      getInstanceBackend()({
        method: "POST",
        url: "/register-continue",
        data: formData,
        // {
        //   hash: hash,
        //   "username-desired": usernameDesire,
        //   password: password,
        //   "nationality-country-iso2": nationalityCountryIso2,
        //   "nationality-id": nationalityId,
        //   "nationality-doc": nationalityDoc,
        //   "nationality-doc-file": "",
        //   "address-country-iso2": addressCountryIso2,
        //   "address-country": addressCountry,
        //   "address-street-and-numbers": address,
        //   "address-post-code": addressPostCode,
        //   "address-city": addressCity,
        //   "address-doc": addressDoc,
        //   "address-doc-file": "",
        // },
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          dispatch({
            type: "POST_REGISTER_CONTINUE",
            payload: {
              RegisterContinueResponse: response.data.success,
              message: response.data.message,
            },
          });
        })
        .catch((error) => {
          // do nothing
          console.log("error in postRegisterContinue", error);
        });
    });
  };
}

export function isValidPasswordHash(hash: string | null, valid: string | null) {
  return function action(dispatch: any) {
    const request = getInstanceBackend()({
      method: "GET",
      url: "/register-password-redefine-hash",
      params: {
        sel: hash,
        valid: valid,
      },
    });
    return request
      .then((response) => {
        dispatch({
          type: "IS_VALID_HASH_PASSWORD",
          payload: {
            isValid: response.data.valid,
            // hash: hash,
          },
        });
      })
      .catch((error) => {
        // do nothing
        console.log("error in isValidPasswordHash", error);
      });
  };
}

export function postRegisterNewPassword(sel: string, valid: string, username: string, password: string) {
  return function action(dispatch: any) {
    getInstanceBackend()({
      method: "POST",
      url: "/register-password-redefine",
      data: {
        sel: sel,
        valid: valid,
        username: username,
        password: password,
      },
    })
      .then((response) => {
        dispatch({
          type: "POST_REGISTER_NEW_PASSWORD",
          payload: {
            message: response.data.message,
            success: response.data.success,
          },
        });
      })
      .catch((error) => {
        console.log("error in postRegisterNewPassword", error);
      });
  };
}

export function forgotPassword(email: string, lang: string) {
  return function action(dispatch: any) {
    const request = getInstanceBackend()({
      method: "GET",
      url: "/forgot-password",
      params: {
        email: email,
        lang: lang,
      },
    });
    return request
      .then((response) => {
        dispatch({
          type: "FORGOT_PASSWORD_RESPONSE",
          payload: response.data,
        });
      })
      .catch((error) => {
        // do nothing
        console.log("error in isValidHash", error);
      });
  };
}

export function resetResponseFirst() {
  return {
    type: "RESET_RESPONSE",
  };
}

export function resetResponseSecond() {
  return {
    type: "RESET_RESPONSE_SECOND",
  };
}

export function resetResponsePassword() {
  return {
    type: "RESET_RESPONSE_PASSWORD",
  };
}

export function getAgentInfo() {
  const agentCookieValue = getCookieValue(AGENT_COOKIE_NAME);

  return function action(dispatch: any) {
    let params: any = {};
    if (agentCookieValue) {
      params.aid = agentCookieValue;
    }

    getInstanceBackend()({
      method: "get",
      url: "/agent-info/",
      params: params,
    })
      .then((response) => {
        dispatch({
          type: "UPDATE_AGENT_INFO",
          payload: response.data,
        });
      })
      .catch((error) => {
        // do nothing
        console.log("error in getAgentInfo", error);
      });
  };
}
